<template>
  <div v-if="isorderDeliveryReport" class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content" @click.self="close">
    <div class="relative w-full lg:w-[83%] max-h-screen bg-[#f8f8f8] p-[40px] overflow-auto">
      <button class="absolute right-12 top-12 cursor-pointer z-10" type="button" @click="close">
        <span class="mdi text-xl mdi-close"></span>
      </button>
      <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
        <h2 class="text-[#353535] text-[20px] leading-[28px] font-semibold">
          Viewing Orders Report: Order Delivery Report
        </h2>
        <div
          class="flex xs:flex-col xl:flex-row xs:justify-start xl:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 xl:items-center">
          <p class="text-[#353535] text-[14px] leading-[20px] font-medium">
            All order delivery reports for this year
          </p>
          <div class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center">
            <button @click="showFilterModal"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none">
              <span><img src="/assets/icon/sort.svg" alt="" /></span>
              Filters
            </button>

            <!-- First Dropdown: Export Data -->
            <div class="dropdown">
              <button
                class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
                id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa-solid fa-chevron-down"></i> Export Data
              </button>
              <ul class="dropdown-menu shadow-none" aria-labelledby="dropdownMenuButton1">
                <li @click="exportToCSV"
                  class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]">
                  Export to CSV
                </li>
                <li @click="exportToPDF"
                  class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[12px] px-[16px]">
                  Export to PDF
                </li>
              </ul>
            </div>
            <div class="dropdown">
              <button
                class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
                id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa-solid fa-chevron-down"></i> Export All
              </button>
              <ul class="dropdown-menu shadow-none" aria-labelledby="dropdownMenuButton2">
                <li @click="exportAllData" :disabled="isExportAllLoading"
                  class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[12px] px-[16px]">
                  <span v-if="isExportAllLoading" class="fa-solid fa-spinner fa-spin"></span>
                  {{ isExportAllLoading ? "Loading..." : "Export All to CSV" }}
                </li>
                <li @click="exportAllToPDF" :disabled="isExportAllLoading"
                  class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[12px] px-[16px]">
                  <span v-if="isExportAllLoading" class="fa-solid fa-spinner fa-spin"></span>
                  {{ isExportAllLoading ? "Loading..." : "Export All to PDF" }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table p-0 m-0 dataTable no-footer text-nowrap">
            <thead>
              <tr>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Delivery Number
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  SAP Order Number
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Distributor Name
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Distributor Code
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  SAP Creation Date
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  DMS Received Date
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Delivery Confirmation Date
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Delivery Confirmation Time
                </th>
                <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                  Status
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                    <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                    <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px">
                      Please wait
                    </h3>
                  </div>
                </td>
              </tr>
              <template v-else>
                <tr v-for="item in ReportItems" :key="item.id">
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ item.deliveryNumber }}
                  </td>
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ item.salesOrderNumber }}
                  </td>
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ item.order.parent.name }}
                  </td>
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ item.order.parent.code }}
                  </td>
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ formatDate(item.sapDeliveryRaisedDate) }}
                  </td>
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ formatDate(item.created) }}
                  </td>
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ formatDate(item.confirmedDate) }}
                  </td>
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ formatTime(item.confirmedDate) }}
                  </td>
                  <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                    {{ item.isConfirmed ? "Confirmed" : "Not Confirmed" }}
                  </td>
                </tr>
                <tr v-if="!ReportItems.length">
                  <td colspan="12">
                    <div class="text-center">No matching records</div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <Pagination :limit="pageSize" :count="pageCount" :page="pageNumber" :itemsCount="count" @changePage="gotoPage"
            @changeLimit="changeLimit" />
        </div>
      </div>
    </div>
    <div class="modal fade py-1" id="mod-filter" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
              Filter
            </h4>
            <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[16px]">
              <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">Start Date</label>
              <div>
                <input type="date" :max="maxDate" placeholder="Select a date" v-model="filter.dateStart"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none" />
              </div>
              <div class="my-[16px]">
                <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">End Date</label>
                <input type="date" :max="maxDate"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  placeholder="Select a date" v-model="filter.dateEnd" />
              </div>
            </div>
            <div>
              <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">Distributors</label>
              <multiselect v-model="filter.distributorID" :options="distributorOptions" :multiple="true" label="value"
                track-by="key" placeholder="Select a Distributor"></multiselect>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button" @click="clearFilters">
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button" @click="handleSearch">
              {{ loading ? "Loading..." : "Search" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- pdf -->
    <vue-html2pdf ref="html2Pdf" :show-layout="false" :float-layout="true" :enable-download="true"
      :preview-modal="false" :paginate-elements-by-height="1400" filename="delivery_report" :pdf-quality="2"
      :manual-pagination="true" pdf-format="a4" pdf-orientation="landscape" pdf-content-width="100%">
      <section slot="pdf-content" class="w-full p-[24px] bg-white text-sm">
        <div class="mb-[24px] avoid-break">
          <h2 class="text-xl font-semibold mb-[8px]">Order Delivery Report</h2>
          <p class="text-sm text-gray-600">
            Generated on {{ formatDate(new Date()) }}
          </p>
        </div>
        <table class="w-full border-collapse border border-gray-300">
          <thead>
            <tr class="bg-gray-100 avoid-break">
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Delivery No.
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                SAP Order No.
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Distributor Name
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Distributor Code
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                SAP Creation Date
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                DMS Received Date
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Delivery Confirmation Date
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Delivery Confirmation Time
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in pdfReportItems" :key="item.id || index" class="avoid-break">
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ item.deliveryNumber }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ item.salesOrderNumber }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ getSafeNestedValue(item, "order.parent.name") }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ getSafeNestedValue(item, "order.parent.code") }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ formatDate(item.sapDeliveryRaisedDate) }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ formatDate(item.created) }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ formatDate(item.confirmedDate) }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ formatTime(item.confirmedDate) }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ item.isConfirmed ? "Confirmed" : "Not Confirmed" }}
              </td>
            </tr>
            <tr v-if="!pdfReportItems.length">
              <td colspan="9" class="border border-gray-300 p-[16px] text-center">
                No data available
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="pdfReportItems.length" class="html2pdf__page-break"></div>
      </section>
    </vue-html2pdf>
    <vue-html2pdf ref="html2PdfAll" :show-layout="false" :float-layout="true" :enable-download="true"
      :preview-modal="false" :paginate-elements-by-height="1400" filename="delivery_report_all" :pdf-quality="2"
      :manual-pagination="true" pdf-format="a4" pdf-orientation="landscape" pdf-content-width="100%">
      <section slot="pdf-content" class="w-full p-[24px] bg-white text-sm">
        <div class="mb-[24px] avoid-break">
          <h2 class="text-xl font-semibold mb-[8px]">
            Order Delivery Report (All Data)
          </h2>
          <p class="text-sm text-gray-600">
            Generated on {{ formatDate(new Date()) }}
          </p>
          <p class="text-sm text-gray-600">
            Total Records: {{ ExportReportItemsAll.length }}
          </p>
        </div>
        <table class="w-full border-collapse border border-gray-300">
          <thead>
            <tr class="bg-gray-100 avoid-break">
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Delivery No.
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                SAP Order No.
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Distributor Name
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Distributor Code
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                SAP Creation Date
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                DMS Received Date
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Delivery Confirmation Date
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Delivery Confirmation Time
              </th>
              <th class="border border-gray-300 text-[10px] leading-[18px] text-[#000000] font-normal py-[10px]">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in ExportReportItemsAll" :key="item.id || index" class="avoid-break">
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ item.deliveryNumber }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ item.salesOrderNumber }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ getSafeNestedValue(item, "order.parent.name") }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ getSafeNestedValue(item, "order.parent.code") }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ formatDate(item.sapDeliveryRaisedDate) }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ formatDate(item.created) }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ formatDate(item.confirmedDate) }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ formatTime(item.confirmedDate) }}
              </td>
              <td class="border border-gray-300 text-[12px] font-normal leading-[16.94px] text-[#353535] py-[10px]">
                {{ item.isConfirmed ? "Confirmed" : "Not Confirmed" }}
              </td>
            </tr>
            <tr v-if="!ExportReportItemsAll.length">
              <td colspan="9" class="border border-gray-300 p-[16px] text-center">
                No data available
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="ExportReportItemsAll.length" class="html2pdf__page-break"></div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
/* eslint-disable */
import { helper } from "@/helper";
import moment from "moment";
import Pagination from "../Pagination.vue";
import Multiselect from "vue-multiselect";
import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "OrderDeliveryReport",
  components: {
    Pagination,
    Multiselect,
    VueHtml2pdf,
  },
  props: ["close"],
  created() {
    this.getDeliveryReport();
  },
  data() {
    return {
      isorderDeliveryReport: true,
      showFilter: false,
      pageNumber: 1,
      pageSize: 10,
      count: 0,
      pageCount: 0,
      ReportItems: [],
      ExportReportItemsAll: [],
      hasNext: false,
      hasPrev: false,
      loading: false,
      isBusy: false,
      isExportAllLoading: false,
      filter: {
        dateStart: "",
        dateEnd: "",
        distributorID: [],
      },
      maxDate: "",
      distributors: [],
      distributorOptions: [],
      exportThreshold: 500,
    };
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    selectedDistributorIds() {
      if (
        !this.filter.distributorID ||
        !Array.isArray(this.filter.distributorID)
      ) {
        return [];
      }
      const ids = this.filter.distributorID
        .map((item) => {
          return typeof item === "object" ? item.key : item;
        })
        .filter((id) => id !== null && id !== undefined);
      return ids;
    },
    pdfReportItems() {
      return this.ReportItems;
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
    this.getMerchants();
  },
  methods: {
    getSafeNestedValue(obj, path) {
      return path.split(".").reduce((current, key) => {
        return current && current[key] !== undefined ? current[key] : "";
      }, obj);
    },

    async exportToPDF() {
      try {
        if (!this.ReportItems.length) {
          this.$toast.error("No data to export.");
          return;
        }

        if (this.count >= this.exportThreshold) {
          await this.performRemoteExport("pdf");
          return;
        }

        this.isBusy = true;
        await this.$nextTick();
        if (this.$refs.html2Pdf && this.$refs.html2Pdf.generatePdf) {
          await this.$refs.html2Pdf.generatePdf();
        } else {
          this.$toast.error("PDF export failed. Please try again.");
        }
      } catch (error) {
        this.$toast.error("An error occurred while exporting PDF.");
      } finally {
        this.isBusy = false;
      }
    },
    async exportAllToPDF() {
      if (this.isExportAllLoading) return;

      if (this.count >= this.exportThreshold) {
        this.isExportAllLoading = true;
        try {
          await this.performRemoteExport("pdf");
          return;
        } catch (error) {
          this.$toast.error(
            "An error occurred while exporting all data to PDF."
          );
        } finally {
          this.isExportAllLoading = false;
        }
      }

      this.isExportAllLoading = true;
      try {
        await this.getDeliveryReport(true);
        if (!this.ExportReportItemsAll.length) {
          this.$toast.error(
            "No data available to export. Please check the filters or try a different date range."
          );
          return;
        }
        await this.$nextTick();
        setTimeout(() => {
          if (this.$refs.html2PdfAll && this.$refs.html2PdfAll.generatePdf) {
            this.$refs.html2PdfAll.generatePdf();
          } else {
            this.$toast.error("PDF export failed. Please try again.");
          }
        }, 100);
      } catch (error) {
        console.error("Error exporting all data to PDF:", error);
        this.$toast.error("An error occurred while exporting all data to PDF.");
      } finally {
        this.isExportAllLoading = false;
      }
    },
    async handleSearch() {
      await this.getDeliveryReport();
      $("#mod-filter").modal("hide");
    },
    formatDate(date) {
      return date ? moment(date).format("ll") : "";
    },
    formatTime(date) {
      return date ? moment(date).format("LT") : "";
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
    showFilterModal() {
      this.pageNumber = 1;
      $("#mod-filter").modal("show");
    },
    clearFilters() {
      this.filter = {
        dateStart: "",
        dateEnd: "",
        distributorID: [],
      };
      this.getDeliveryReport();
      $("#mod-filter").modal("hide");
    },
    async getMerchants() {
      this.loading = true;
      this.isBusy = true;
      try {
        const res = await this.$http.get("/Accounts/getListNoPagination");
        this.distributors = res.body || [];
        this.distributorOptions = this.distributors.map((distributor) => ({
          key: distributor.id,
          value: distributor.name,
        }));
      } catch (error) {
        console.error("Error fetching merchants:", error);
      } finally {
        this.loading = false;
        this.isBusy = false;
      }
    },
    async getDeliveryReport(isExport = false) {
      try {
        this.isBusy = true;
        if (!isExport) {
          this.loading = true;
        }
        const params = new URLSearchParams();
        params.append(
          "pageNumber",
          isExport ? "1" : this.pageNumber.toString()
        );
        params.append(
          "pageSize",
          isExport ? "99999999" : this.pageSize.toString()
        );
        params.append("isExport", isExport.toString());

        if (this.filter.dateStart && moment(this.filter.dateStart).isValid()) {
          params.append(
            "startDate",
            moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
          );
        }
        if (this.filter.dateEnd && moment(this.filter.dateEnd).isValid()) {
          params.append(
            "endDate",
            moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
          );
        }
        if (this.selectedDistributorIds.length > 0) {
          this.selectedDistributorIds.forEach((id) => {
            params.append("distributorIds", id);
          });
        }

        const url = `/Reports/getDeliveriesReport?${params.toString()}`;
        const res = await this.$http.get(url);
        if (isExport) {
          this.ExportReportItemsAll = res.body.data || [];
          return this.ExportReportItemsAll;
        } else {
          this.ReportItems = [...(res.body.data || [])];
          this.pageNumber = res.body.pageNumber || 1;
          this.pageSize = res.body.pageSize || this.pageSize;
          this.count = res.body.count || 0;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize) || 0;
          this.hasPrev = this.pageNumber > 1;
          this.hasNext = this.pageNumber < this.pageCount;
        }
      } catch (error) {
        console.error("Error fetching delivery report:", error);
      } finally {
        this.isBusy = false;
        if (!isExport) {
          this.loading = false;
        }
      }
    },

    async performRemoteExport(fileType) {
      try {
        this.isBusy = true;
        const params = new URLSearchParams();
        params.append("pageNumber", "1");
        params.append("pageSize", "99999999");
        params.append("isExport", "true");
        params.append("fileType", fileType);

        if (this.filter.dateStart && moment(this.filter.dateStart).isValid()) {
          params.append(
            "startDate",
            moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
          );
        }
        if (this.filter.dateEnd && moment(this.filter.dateEnd).isValid()) {
          params.append(
            "endDate",
            moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
          );
        }
        if (this.selectedDistributorIds.length > 0) {
          this.selectedDistributorIds.forEach((id) => {
            params.append("distributorIds", id);
          });
        }

        const url = `/Reports/exportDeliveriesReport?${params.toString()}`;
        const res = await this.$http.post(url, {});
        const message =
          res.body && res.body.message
            ? res.body.message
            : "Report has been queued. Please check Queued Reports to access your report";
        this.$toast.success(message);
      } catch (error) {
        console.error("Error performing remote export:", error);
        this.$toast.error("An error occurred while initiating the export.");
      } finally {
        this.isBusy = false;
      }
    },

    async exportToCSV() {
      if (!this.ReportItems.length) {
        alert("No data to export.");
        return;
      }

      if (this.count >= this.exportThreshold) {
        await this.performRemoteExport("csv");
        return;
      }

      const headers = [
        "Delivery Number",
        "Created Date",
        "Distributor Code",
        "Distributor Name",
        "Delivery Confirmation Date",
        "Delivery Confirmation Time",
        "SAP Order Number",
        "Status",
      ];
      const rows = this.ReportItems.map((item) => [
        `"${item.deliveryNumber || ""}"`,
        `"${this.formatDate(item.created)}"`,
        `"${(item.order && item.order.parent && item.order.parent.code) ||
        ""}"`,
        `"${(item.order && item.order.parent && item.order.parent.name) ||
        ""}"`,
        `"${this.formatDate(item.confirmedDate)}"`,
        `"${this.formatTime(item.confirmedDate)}"`,
        `"${item.salesOrderNumber || ""}"`,
        `"${item.isConfirmed ? "Confirmed" : "Not Confirmed"}"`,
      ]);
      let csvContent =
        "data:text/csv;charset=utf-8," +
        headers.map((header) => `"${header}"`).join(",") +
        "\n" +
        rows.map((row) => row.join(",")).join("\n");
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        `delivery_report_${moment().format("YYYY-MM-DD")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async exportAllData() {
      if (this.count >= this.exportThreshold) {
        this.isExportAllLoading = true;
        try {
          await this.performRemoteExport("csv");
          return;
        } catch (error) {
          this.$toast.error("An error occurred while exporting all data.");
        } finally {
          this.isExportAllLoading = false;
        }
      }

      this.isExportAllLoading = true;
      try {
        await this.getDeliveryReport(true);
        if (!this.ExportReportItemsAll.length) {
          alert(
            "No data available to export. Please check the filters or try a different date range."
          );
          return;
        }
        const headers = [
          "Delivery Number",
          "Created Date",
          "Distributor Code",
          "Distributor Name",
          "Delivery Confirmation Date",
          "Delivery Confirmation Time",
          "SAP Order Number",
          "Status",
        ];

        const rows = this.ExportReportItemsAll.map((item) => [
          `"${item.deliveryNumber || ""}"`,
          `"${this.formatDate(item.created)}"`,
          `"${(item.order && item.order.parent && item.order.parent.code) ||
          ""}"`,
          `"${(item.order && item.order.parent && item.order.parent.name) ||
          ""}"`,
          `"${this.formatDate(item.confirmedDate)}"`,
          `"${this.formatTime(item.confirmedDate)}"`,
          `"${item.salesOrderNumber || ""}"`,
          `"${item.isConfirmed ? "Confirmed" : "Not Confirmed"}"`,
        ]);

        let csvContent =
          "data:text/csv;charset=utf-8," +
          headers.map((header) => `"${header}"`).join(",") +
          "\n" +
          rows.map((row) => row.join(",")).join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute(
          "download",
          `delivery_report_all_${moment().format("YYYY-MM-DD")}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error exporting all data:", error);
        alert(
          "An error occurred while exporting data. Please try again later."
        );
      } finally {
        this.isExportAllLoading = false;
      }
    },
    prev() {
      if (this.pageNumber > 1) {
        this.pageNumber -= 1;
        this.getDeliveryReport();
      }
    },
    next() {
      if (this.hasNext) {
        this.pageNumber += 1;
        this.getDeliveryReport();
      }
    },
    gotoPage(page) {
      this.pageNumber = page;
      this.getDeliveryReport();
    },
    changeLimit(limit) {
      this.pageSize = limit;
      this.pageNumber = 1;
      this.getDeliveryReport();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
/* Prevent content from breaking inside */
.avoid-break {
  page-break-inside: avoid;
  break-inside: avoid;
}

/* Ensure table headers and rows stay together */
table {
  page-break-inside: auto;
}

tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

thead {
  display: table-header-group;
}

/* Adjust margins for better spacing */
section {
  margin: 0;
  padding: 24px;
}

/* Ensure page breaks are handled by vue-html2pdf */
.html2pdf__page-break {
  page-break-before: always;
}
</style>
